import * as T from "../constants";

export const getAddressValidation = (payload, handleAddressValidation, historyProps) => ({
    type: T.MAILING_ADDRESS_ENTERED,
    payload: {
        payload,
        handleAddressValidation,
        historyProps
    }
})

export const submitPrivacyRequest = (payload, routeProps, historyProps) => ({
    type: T.SUBMIT_PRIVACY_REQUEST,
    payload: {
        payload,
        routeProps,
        historyProps
    }
})
